module.exports = __webpack_public_path__ + "static/media/Qin Li.a0b8cf83.png";